const booking = {
  bookingInformation: "Užsakymo informacija", // translated 
  cancellationPolicy: "Atšaukimo politika", // translated 
  ourCancellationPolicy: "Mūsų atšaukimo politika", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "Tai pakeičia bet kokią anksčiau pateiktą atšaukimo politiką", // translated 
  thisBookingIsNonNefundable: "Šis užsakymas yra negrąžinamas", // translated 
  paymentTerms: "Mokėjimo sąlygos", // translated 
  paymentWillBeTakenFromYourDefault: "Mokėjimas bus paimtas iš numatytojo", // translated 
  paymentMethod: "mokėjimo būdas", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "po nemokamo atšaukimo laikotarpio, jei taikoma", // translated 
  prebook: "Išankstinė knyga", // translated 
  guests: "Svečiai", // translated 
  payment: "Mokėjimas", // translated 
  byClicking: "Spustelėjus", // translated 
  youAreAgreeingToOur: "jūs sutinkate su mūsų", // translated 
  termsAndConditions: "Taisyklės ir sąlygos", // translated 
  lastBookableDate: "Paskutinė užsakymo data", // translated 
  customerRemarksTextfield: "Klientų pastabos", // translated 
  request: "Prašymas", // translated 
};



export default booking;
